import { render, staticRenderFns } from "./DangerDialog.vue?vue&type=template&id=6328fd2a&scoped=true"
import script from "./DangerDialog.vue?vue&type=script&lang=ts"
export * from "./DangerDialog.vue?vue&type=script&lang=ts"
import style0 from "./DangerDialog.vue?vue&type=style&index=0&id=6328fd2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6328fd2a",
  null
  
)

export default component.exports